import { TaxBillSheetDto } from "src/dtos/taxBill/taxBillSheetDto";
import { TaxBillViewDto } from "src/dtos/taxBill/taxBillViewDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SAL2070_R01Dto extends TaxBillViewDto {

	allCount: number,
	tradeNoList: string[],

	//TaxBillSheetDto의 정보중 필요한 내용을 추가로 기입
	taxBillNo: string,				// 세금계산서번호(기본키)
	taxType: string,				// 매입매출여부 I/O "VAT_IO_FLAG"
	// compCd: string,
	// customCd: string,
	issuedDt: string | undefined,		// 발행일자
	taxBillCreate: string,			// 세금계산서발행자 in/out
	vatType: string,				// 부가세유형
	vatRate: number,				// 부가세 율
	netAmt: number,					// 명세서합계액
	moneyCd: string,				// 화폐유형
	exchangeRate: number,			// 환율
	vatIncludeFlag: string,			// 공급가 부가세포함여부(Y.N)
	// billAmt: number,				// 공급가액
	// vatAmt: number,
	// taxEmpNo: string,			// 세금계산서담당
	dtlDt: string | undefined,		// 항목 일자
	dtlItemNm: string,				// 항목 품명
	dtlItemSpec: string,			// 항목 규격
	dtlItemQty: number,				// 항목 수량
	dtlItemCost: number,			// 항목 단가
	dtlItemAmt: number,				// 항목 금액
	fixedFlag: string,				// 확정여부YN
	inoutAutoFlag: string,			// 출고처리동시생성여부
	ntsApproveNo: string,			// 국세청 승인번호
	remark: string,					// 비고

	itemCount: number,

}

export const defaultSAL2070_R01Dto: SAL2070_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	allCount: 0,
	tradeNoList: [],

	tradeNo: "",
	itemCd: "",
	itemNm: "",
	unit: "",
	price: 0,
	qty: 0,
	dcAmt: 0,
	itemAmt: 0,
	itemAmtValidation: "INVALID",
	tradeType: "",
	compCd: "",
	compNm: "",
	customCd: "",
	customNm: "",
	vatType: "",
	billAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	tradeDt: formatDate(new Date()),
	taxBilling: "N",
	taxBillNo: "",
	empNo: "",
	empNm: "",
	taxEmpNo: "",
	taxEmpNm: "",
	approveFlg: 'N',
	transportItemNo: "",


	taxType: "",
	issuedDt: formatDate(new Date()),
	taxBillCreate: "",
	vatRate: 0,
	netAmt: 0,
	moneyCd: "",
	exchangeRate: 0,
	vatIncludeFlag: "",
	dtlDt: formatDate(new Date()),
	dtlItemNm: "",
	dtlItemSpec: "",
	dtlItemQty: 0,
	dtlItemCost: 0,
	dtlItemAmt: 0,
	fixedFlag: "",
	inoutAutoFlag: "",
	ntsApproveNo: "",
	remark: "",

	itemCount: 0,

	inserted: false,
	isModified: false
}
